import React from 'react';
import { PREVIOUS_BEHAVIOURS, COMPARISON_BEHAVIOURS, labelForPreviousBehaviour } from '../../adapters';

const PreviousRaTab = ({ field, fields, readOnly, onChange }) => {
  const cfg = field.metadata?.businessConfig || {};
  const patchCfg = (patch) => onChange({
    metadata: {
      ...(field.metadata || {}),
      businessConfig: { ...cfg, ...patch },
    },
  });
  const opts = (fields || []).filter((f) => String(f.status || 'ACTIVE') === 'ACTIVE');
  const behaviour = cfg.previousBehaviour || 'SAME_FIELD';
  const prevFieldCode = behaviour === 'OTHER_FIELD'
    ? (cfg.previousFieldCode || '')
    : field.fieldCode;
  const prevFieldLabel = (fields || []).find((f) => f.fieldCode === prevFieldCode)?.fieldLabel
    || prevFieldCode
    || field.fieldLabel
    || field.fieldCode;

  return (
    <div className="ra-tpl-tab-body">
      <div className="ra-tpl-ra2-explain">
        <strong>Dependency chain (same template for every RA)</strong>
        <p>
          RA-2 depends on <strong>RA-1</strong>. RA-3 depends on <strong>RA-2</strong>. RA-4 depends on <strong>RA-3</strong>.
          Always the immediate previous bill only — never jumps back to RA-1.
        </p>
        <ul>
          <li><strong>RA-1:</strong> Previous = 0 · Current = this bill</li>
          <li>
            <strong>RA-n (n≥2):</strong> Previous = value of{' '}
            <em>{prevFieldLabel}</em> frozen on RA-(n−1) · Current = this bill · Since Previous = Current − Previous
          </li>
        </ul>
      </div>

      <div className="form-group">
        <label>Where does the Previous column come from? (RA-2 onwards)</label>
        <div className="ra-tpl-radio-list">
          {PREVIOUS_BEHAVIOURS.map((o) => (
            <label key={o.value}>
              <input
                type="radio"
                disabled={readOnly}
                name={`prev-${field.fieldCode}`}
                checked={behaviour === o.value}
                onChange={() => patchCfg({
                  previousBehaviour: o.value,
                  previousFieldCode: o.value === 'SAME_FIELD' ? field.fieldCode : cfg.previousFieldCode,
                })}
              />
              {o.label}
            </label>
          ))}
        </div>
        <p className="ra-tpl-help">
          Default “same field” means: on RA-2, Previous shows this field&apos;s frozen value from RA-1.
        </p>
      </div>

      {behaviour === 'OTHER_FIELD' && (
        <div className="form-group">
          <label>Which field from the previous RA bill?</label>
          <select
            disabled={readOnly}
            value={cfg.previousFieldCode || ''}
            onChange={(e) => patchCfg({ previousFieldCode: e.target.value || null })}
          >
            <option value="">— Select —</option>
            {opts.map((f) => (
              <option key={f.fieldCode} value={f.fieldCode}>{f.fieldLabel || f.fieldCode}</option>
            ))}
          </select>
        </div>
      )}

      <div className="form-group">
        <label>First bill (RA-1)</label>
        <select disabled value="0">
          <option value="0">Previous column = 0</option>
        </select>
      </div>

      <div className="form-group">
        <label>Comparison on the bill form</label>
        <select
          disabled={readOnly}
          value={cfg.comparisonBehaviour || 'CURRENT_MINUS_PREVIOUS'}
          onChange={(e) => patchCfg({ comparisonBehaviour: e.target.value })}
        >
          {COMPARISON_BEHAVIOURS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <p className="ra-tpl-help">
          One field only. Current / Previous / Since Previous are three columns of the same field — not three template fields.
          Active setting: {labelForPreviousBehaviour(behaviour)}.
        </p>
      </div>
    </div>
  );
};

export default PreviousRaTab;
